export const getAllRoles = async ($fire: any) => {
  return await $fire.firestore.collection('roles').get()
}
